<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="980">
    <v-card class="resumen-print">
      <v-card-title class="text-h6">
        Resultado creación programas ESAM
      </v-card-title>
      <v-card-text v-if="reporte">
        <v-row dense class="mb-3">
          <v-col cols="6" sm="3">
            <v-alert dense text type="success" class="mb-0">Creados: {{ reporte.total_creados }}</v-alert>
          </v-col>
          <v-col cols="6" sm="3">
            <v-alert dense text type="error" class="mb-0">Fallidos: {{ reporte.total_fallidos }}</v-alert>
          </v-col>
          <v-col cols="6" sm="3">
            <v-alert dense text type="info" class="mb-0">Omitidos: {{ reporte.total_omitidos }}</v-alert>
          </v-col>
          <v-col cols="6" sm="3">
            <v-alert dense text type="warning" class="mb-0">Solicitados: {{ reporte.total_solicitados }}</v-alert>
          </v-col>
        </v-row>

        <div class="text-subtitle-2 mb-2 green--text text--darken-2">Creados correctamente</div>
        <v-simple-table dense class="mb-4">
          <thead>
            <tr>
              <th>ID Prog. Univ.</th>
              <th>ID ESAM</th>
              <th>Nombre compuesto</th>
              <th>Sede</th>
              <th>Responsable</th>
              <th>Módulos</th>
              <th>Planes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in reporte.creados" :key="'ok-'+item.programa_universidad_id">
              <td>{{ item.programa_universidad_id }}</td>
              <td>{{ item.programa_id }}</td>
              <td>{{ item.nombre_compuesto }}</td>
              <td>{{ item.sede ? item.sede.nombre : '—' }}</td>
              <td>
                <div v-if="item.responsable">
                  <div>{{ item.responsable.nombre || 'Responsable asignado' }}</div>
                  <div class="caption grey--text">ID portal: {{ item.responsable.responsable_id }}</div>
                </div>
                <span v-else class="grey--text">Sin responsable</span>
                <div v-if="item.responsable_advertencia" class="caption orange--text text--darken-3">
                  {{ item.responsable_advertencia }}
                </div>
              </td>
              <td>{{ item.modulos_count }}</td>
              <td>{{ item.planes_count }}</td>
            </tr>
            <tr v-if="!reporte.creados.length">
              <td colspan="7" class="text--secondary">Sin programas creados.</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-2 mb-2 red--text text--darken-2">No creados</div>
        <v-simple-table dense class="mb-4">
          <thead>
            <tr>
              <th>ID Prog. Univ.</th>
              <th>Programa universidad</th>
              <th>Sede</th>
              <th>Etapa</th>
              <th>Error</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in reporte.fallidos" :key="'fail-'+i">
              <td>{{ item.programa_universidad_id || '—' }}</td>
              <td>{{ item.programa_universidad_nombre || '—' }}</td>
              <td>{{ item.sede ? item.sede.nombre : '—' }}</td>
              <td>{{ item.etapa }}</td>
              <td>{{ item.error }}</td>
            </tr>
            <tr v-if="!reporte.fallidos.length">
              <td colspan="5" class="text--secondary">Sin errores.</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-2 mb-2 blue--text text--darken-2">Omitidos por creación previa</div>
        <v-simple-table dense class="mb-4">
          <thead>
            <tr>
              <th>ID Prog. Univ.</th>
              <th>ID ESAM</th>
              <th>Programa universidad</th>
              <th>Nombre compuesto</th>
              <th>Sede</th>
              <th>Responsable</th>
              <th>Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in reporte.omitidos" :key="'skip-'+item.programa_universidad_id">
              <td>{{ item.programa_universidad_id }}</td>
              <td>{{ item.programa_id || '—' }}</td>
              <td>{{ item.programa_universidad_nombre }}</td>
              <td>{{ item.nombre_compuesto || '—' }}</td>
              <td>{{ item.sede ? item.sede.nombre : '—' }}</td>
              <td>
                <div v-if="item.responsable">
                  <div>{{ item.responsable.nombre || 'Responsable asignado' }}</div>
                  <div class="caption grey--text">ID portal: {{ item.responsable.responsable_id }}</div>
                </div>
                <span v-else class="grey--text">—</span>
              </td>
              <td>{{ item.motivo }}</td>
            </tr>
            <tr v-if="!reporte.omitidos.length">
              <td colspan="7" class="text--secondary">Sin omitidos.</td>
            </tr>
          </tbody>
        </v-simple-table>

        
      </v-card-text>
      <v-card-actions class="no-print">
        <v-spacer />
        <v-btn
          color="teal darken-2"
          class="white--text" 
          @click="cerrar"
        >
          Cerrar resumen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalVerResumen',
  data() {
    return {
      dialog: false,
      reporte: null,
      confirmarCierre: '',
    };
  },
  methods: {
    openmodal(reporte) {
      this.reporte = reporte;
      this.confirmarCierre = '';
      this.dialog = true;
    },
    cerrar() {
      this.dialog = false;
      this.confirmarCierre = '';
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
@media print {
  @page {
    size: landscape;
    margin: 10mm;
  }

  body * {
    visibility: hidden !important;
  }

  .resumen-print,
  .resumen-print * {
    visibility: visible !important;
  }

  .no-print,
  .no-print * {
    display: none !important;
    visibility: hidden !important;
  }

  .v-dialog__content,
  .v-dialog,
  .v-overlay,
  .v-overlay__content {
    position: static !important;
    display: block !important;
    align-items: initial !important;
    justify-content: initial !important;
    width: auto !important;
    height: auto !important;
    max-width: none !important;
    max-height: none !important;
    overflow: visible !important;
    background: transparent !important;
    box-shadow: none !important;
    transform: none !important;
  }

  .v-overlay__scrim {
    display: none !important;
  }

  .resumen-print {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    overflow: visible !important;
  }

  .resumen-print .v-card__title {
    padding: 0 0 8px 0 !important;
    font-size: 16px !important;
    line-height: 1.2 !important;
    color: #000 !important;
  }

  .resumen-print .v-card__text {
    padding: 0 !important;
    overflow: visible !important;
    max-height: none !important;
    color: #000 !important;
  }

  .resumen-print .row {
    display: flex !important;
    flex-wrap: nowrap !important;
    margin: 0 0 8px 0 !important;
  }

  .resumen-print .col,
  .resumen-print [class*="col-"] {
    padding: 2px !important;
  }

  .resumen-print .v-alert {
    border: 1px solid #999 !important;
    padding: 4px 6px !important;
    margin: 0 !important;
    color: #000 !important;
    background: #fff !important;
  }

  .resumen-print .v-data-table,
  .resumen-print .v-data-table__wrapper,
  .resumen-print table {
    width: 100% !important;
    overflow: visible !important;
  }

  .resumen-print table {
    border-collapse: collapse !important;
    table-layout: fixed !important;
    font-size: 9px !important;
    line-height: 1.2 !important;
    page-break-inside: auto !important;
  }

  .resumen-print thead {
    display: table-header-group !important;
  }

  .resumen-print tr {
    page-break-inside: avoid !important;
    page-break-after: auto !important;
  }

  .resumen-print th,
  .resumen-print td {
    border: 1px solid #999 !important;
    padding: 3px 4px !important;
    color: #000 !important;
    white-space: normal !important;
    word-break: break-word !important;
    vertical-align: top !important;
  }

  .resumen-print th {
    font-weight: 700 !important;
    background: #eee !important;
  }

  .resumen-print .text-subtitle-2 {
    margin-top: 10px !important;
    margin-bottom: 4px !important;
    color: #000 !important;
    font-size: 12px !important;
    font-weight: 700 !important;
  }

  .resumen-print .caption,
  .resumen-print .grey--text,
  .resumen-print .orange--text {
    color: #333 !important;
    font-size: 8px !important;
  }
}
</style>
